/* eslint-disable no-unused-vars */
const ALCHEMY_API_URL = process.env.NEXT_PUBLIC_ALCHEMY_API_URL || "";
const QUESTING_RAIDERS = process.env.NEXT_PUBLIC_QUESTING;

import { AbiItem } from "web3-utils";
import axios from "axios";

import Questable from "../../contracts/Questable.json";
import QuestingRaiders from "../../contracts/QuestingRaiders.json";
import Raiders from "../../contracts/Raiders.json";
import Boosted from "../../contracts/BoostedRaiders.json";

import { UseToastOptions } from "@chakra-ui/toast";

import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import { getManyEntities } from "./interactBank";
import { Raider } from "../../types/raider";
const web3 = createAlchemyWeb3(ALCHEMY_API_URL);

export const getAccount = async () => {
	if ((window as any).current_provider) {
		web3.setWriteProvider((window as any).current_provider)
		if ((window as any).current_provider.isMetaMask) {
			//metamask
			return (window as any).current_provider.selectedAddress
		} else {
			return (window as any).current_provider.accounts[0];
		}
	} 
};

const questingContract = new web3.eth.Contract(
	QuestingRaiders.abi as AbiItem[],
	QUESTING_RAIDERS
);

const raiderCharContract = new web3.eth.Contract(
	Raiders.abi as AbiItem[],
	process.env.NEXT_PUBLIC_RAIDER_CHARACTERS
);

const boostedContract = new web3.eth.Contract(
	Boosted.abi as AbiItem[],
	process.env.NEXT_PUBLIC_BOOSTED
);

// ---------- QUEST CONTRACTS ----------

const grimweedQuestContract = new web3.eth.Contract(
	Questable.abi as AbiItem[],
	process.env.NEXT_PUBLIC_GRIMWEED_QUEST
);

const newtQuestContract = new web3.eth.Contract(
	Questable.abi as AbiItem[],
	process.env.NEXT_PUBLIC_NEWT_QUEST
);

const sporebarkQuestContract = new web3.eth.Contract(
	Questable.abi as AbiItem[],
	process.env.NEXT_PUBLIC_SPOREBARK_QUEST
);

// ---------- RAIDERS ----------

export async function areRaidersApproved(quest: string) {
	const account = await getAccount();
	try {
		const result = await raiderCharContract.methods
			.isApprovedForAll(account, quest)
			.call();
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function approveRaidersForQuesting(
	questing: string,
	toast: (options: UseToastOptions) => string | number | undefined
) {
	try {
		const account = await getAccount();
		const result = await raiderCharContract.methods
			.setApprovalForAll(questing, true)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't approve your Raider...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					}
					console.log("Hash of the transaction: " + res);
				}
			);
		return result;
	} catch (err) {
		console.log(err);
	}
}

// ---------- BOOSTED CONTRACT ----------

export async function getRaiderSpeedBoost(raiderId: number) {
	try {
		const result = await boostedContract.methods
			.raiderSpeedBoost(raiderId)
			.call();
		return result;
	} catch (err) {
		console.log(err);
	}
}

// ---------- QUESTS ----------

const questResolver = (quest: string) => {
	if (quest === "GRIMWEED") {
		return grimweedQuestContract;
	} else if (quest === "NEWT") {
		return newtQuestContract;
	} else if (quest === "SPOREBARK") {
		return sporebarkQuestContract;
	} else {
		throw `${quest} invalid quest`;
	}
};

export async function startQuest(
	raiderId: number,
	questString: string,
	toast: (options: UseToastOptions) => string | number | undefined
) {
	const quest = questResolver(questString);
	try {
		const account = await getAccount();
		const result = await quest.methods
			.startQuest(raiderId)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't start your quest...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					}
					console.log("Hash of the transaction: " + res);
				}
			);
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function endQuest(
	raiderId: number,
	questString: string,
	toast: (options: UseToastOptions) => string | number | undefined
) {
	const quest = questResolver(questString);
	try {
		const account = await getAccount();
		const result = await quest.methods
			.endQuest(raiderId)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't end your quest...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					}
					console.log("Hash of the transaction: " + res);
				}
			);
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function runHome(
	raiderId: number,
	questString: string,
	toast: (options: UseToastOptions) => string | number | undefined
) {
	const quest = questResolver(questString);
	try {
		const account = await getAccount();
		const result = await quest.methods
			.runHome(raiderId)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't run home...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					}
					console.log("Hash of the transaction: " + res);
				}
			);
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function getRewards(
	raiderId: number,
	questString: string,
	toast: (options: UseToastOptions) => string | number | undefined
) {
	const quest = questResolver(questString);
	try {
		const account = await getAccount();
		const result = await quest.methods
			.getRewards(raiderId)
			.send(
				{ from: account, maxPriorityFeePerGas: null, maxFeePerGas: null },
				function (err: any, res: any) {
					if (err) {
						toast({
							title: "Couldn't get rewards...",
							description: err.message,
							status: "error",
							duration: 9000,
							position: "top",
							isClosable: true,
						});
						console.log(err);
					}
					console.log("Hash of the transaction: " + res);
				}
			);
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function getQuestStatus(raider: number, questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.raiderStatus(raider).call();
		return result;
	} catch (err) {
		console.log(err);
	}
}

export async function getTimeTillHome(raider: number, questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.timeTillHome(raider).call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

export async function getTotalReturnTime(raider: number, questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.calcReturnTime(raider).call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

export async function getQuestDuration(raider: number, questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.timeQuesting(raider).call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

export async function getEarned(raider: number, questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.calcEarned(raider).call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

export async function getRewardsToCollect(raider: number, questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.rewardEarned(raider).call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

export async function nextReward(raider: number, questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.nextReward(raider).call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

export async function rewardTime(raider: number, questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.calcRaiderRewardTime(raider).call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

export async function minExpForQuest(questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.minProfessionExp().call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

export async function expRewardAmount(questString: string) {
	const quest = questResolver(questString);
	try {
		const result = await quest.methods.experienceAmount().call();
		return Number(result);
	} catch (err) {
		console.log(err);
	}
}

// ---------- QUESTING CONTRACT ----------

export async function questingRaiders() {
	const account = await getAccount();
	try {
		const result = await questingContract.methods
			.getOwnedRaiders(account)
			.call();

		if (result.length) {
			return await getManyEntities(result, 'raiders')
		} else {
			return []
		}
	} catch (err) {
		console.log(err);
	}
}

const questFinder = (contract: string) => {
	if (contract === process.env.NEXT_PUBLIC_GRIMWEED_QUEST) {
		return "GRIMWEED";
	} else if (contract === process.env.NEXT_PUBLIC_NEWT_QUEST) {
		return "NEWT";
	}  else if (contract === process.env.NEXT_PUBLIC_SPOREBARK_QUEST) {
		return "SPOREBARK";
	}
};

export async function getRaiderQuest(raider: number) {
	try {
		const result = await questingContract.methods.raiderQuest(raider).call();
		return questFinder(result);
	} catch (err) {
		console.log(err);
	}
}
